import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-rules-of-use',
  templateUrl: './rules-of-use.component.html',
})

export class RulesOfUseComponent implements OnInit {
  countries: Array<Document> = [
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'Rules-for-the-use-of-an-electric-scooter.html'
    },
    {
      countryName: 'Кыргызстан',
      img: 'kg.svg',
      docHref: 'Rules-for-the-use-of-an-electric-scooter-kg.html'
    },
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'Rules-for-the-use-of-an-electric-scooter-by.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
